export default __webpack_public_path__ + "static/demographics4-95379553ddcc63f94a3cba25c6b6a29e.png";